"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobxReact = require("mobx-react");
var _PropTypeCustomAction = require("../../prop-type-custom-action/PropTypeCustomAction");
var _ServiceRegistry = _interopRequireDefault(require("../../../../../util/ServiceRegistry"));
var _TopBarAction = _interopRequireDefault(require("../../../icons/top-bar-action/TopBarAction"));
var _SaveActionView = _interopRequireDefault(require("../save-action/SaveActionView"));
var _SeparatorView = _interopRequireDefault(require("../separator/SeparatorView"));
require("!style-loader!css-loader!./CustomActions.css");
var _class, _ModernViewerCustomActions;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let ModernViewerCustomActions = (0, _mobxReact.observer)(_class = (_ModernViewerCustomActions = class ModernViewerCustomActions extends _react.Component {
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (!appStore.isInPreview && !appStore.isInEdit || !appStore.enableModernViewer) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    const {
      actions: undoRedoTools
    } = this.props;
    let showUndoRedoTools = false;
    undoRedoTools.forEach(tool => {
      if (!tool.disabled) showUndoRedoTools = true;
    });
    if (appStore.isInEdit) {
      showUndoRedoTools = true;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showUndoRedoTools && undoRedoTools.map(action => /*#__PURE__*/_react.default.createElement(_TopBarAction.default, {
      action: action
    })), /*#__PURE__*/_react.default.createElement(_SaveActionView.default, null), showUndoRedoTools && /*#__PURE__*/_react.default.createElement(_SeparatorView.default, {
      className: "sdk-CustomActions-separator"
    }));
  }
}, _ModernViewerCustomActions.propTypes = {
  actions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeJsonCustomAction, _PropTypeCustomAction.propTypeReactCustomAction])).isRequired
}, _ModernViewerCustomActions)) || _class;
var _default = exports.default = ModernViewerCustomActions;